<template>
  <div>
    <b-modal
      size="xl"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title mr-2">{{ data.period }}會員未繳費資料</h5>

        <convert-excel
          class="btn btn-success btn-sm"
          :data="excel_json.data"
          :fields="excel_json.fields"
          :worksheet="excel_json.worksheet"
          :name="excel_json.name"
          :type="excel_json.type"
        >
          下載
        </convert-excel>

        <button type="button" aria-label="Close" class="close" @click="close()">×</button>
      </template>

      <div class="container-fluid overflow-auto">
        <b-input-group prepend="關鍵字" class="mb-4">
          <b-form-input
            placeholder="請輸入關鍵字"
            v-model.number="search.blur"
            @keyup.enter="getBillFlatten(1)" />

          <b-input-group-append>
            <b-button size="sm" text="Button" variant="success" @click="getBillFlatten(1)">搜尋</b-button>
          </b-input-group-append>
        </b-input-group>

        <tables-page
          :tableData="table_data"
          :tableFields="table_fields"
          v-on:result="getBillFlatten"
        >
          <template #cell(join_date)="row">
            {{ convertRocDate(row.item.join_date, false) }}
          </template>

          <template #cell(type)="row">
            <span :class="getBillTypeColor(row.item.type)">{{ getBillFeeDescription(row.item) }}</span>
          </template>

          <template #cell(dead_line)="row">
            {{ convertRocDate(row.item.dead_line, false) }}
          </template>

          <template #cell(sales_upper_1)="row">
            {{ row.item.sales_upper_1_number }} {{ row.item.sales_upper_1_name }}
          </template>

           <template #cell(sales_upper_2)="row">
            {{ row.item.sales_upper_2_number }} {{ row.item.sales_upper_2_name }}
          </template>
        </tables-page>
      </div>

      <b-overlay :show="status.isLoading" no-wrap></b-overlay>
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import ConvertExcel from "@/components/common/ConvertExcel";
import billApi from "@/models/API/billApi";
import { convertRocDate, convertDateFormat, getFirstAndLastDayOfMonth, getBillTypeColor, getBillFeeDescription } from "@/models/HELPERS/common.js";

export default {
  name: 'billDataReportBillModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  components: {
    TablesPage,
    ConvertExcel
  },
  data () {
    return {
      status: {
        isLoading: false
      },
      search: {
        blur: ''
      },
      table_fields: [
        {
          key: "no",
          label: "序號",
        },
        {
          key: "number",
          label: "契約編號",
          sortable: true
        },
        {
          key: "join_date",
          label: "入會日期",
          sortable: true
        },
        {
          key: "member_name",
          label: "姓名",
          sortable: true
        },
        {
          key: "type",
          label: "類別",
          sortable: true
        },
        {
          key: "pay_name",
          label: "要助人",
          sortable: true
        },
        {
          key: "pay_cellphone",
          label: "要助人手機",
          sortable: true
        },
        {
          key: "dead_line",
          label: "繳款期限",
          sortable: true
        },
        {
          key: "amount",
          label: "互助金",
          sortable: true
        },
        {
          key: "sales_number",
          label: "業務編號",
          sortable: true
        },
        {
          key: "sales_name",
          label: "業務姓名",
          sortable: true
        },
        {
          key: "sales_cellphone",
          label: "業務手機",
          sortable: true
        },
        {
          key: "sales_upper_1",
          label: "上階"
        },
        {
          key: "sales_upper_2",
          label: "上上階"
        },
      ],
      table_data: [],
      page: {},
      table_sort: {
        sortBy: '',
        sort: ''
      },
      excel_json: {
        fields: {},
        data: [],
        worksheet: 'My Worksheet',
        name: '每組每月慰問金統計.csv',
        type: 'csv'
      }
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.getBillFlatten();
        }
      },
      immediate: false
    }
  },
  mounted() {
    this.billApi = new billApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.page = Object.assign({}, this.billApi.page);
    },
    convertRocDate,
    getBillTypeColor,
    getBillFeeDescription,
    // 查詢帳單
    getBillFlatten(pageIndex = null, sortBy = '', sort = '') {
      this.status.isLoading = true;

      if (sortBy) this.table_sort.sortBy = sortBy;
      if (sort) this.table_sort.sort = sort;

      const period_first_date = `${Number(this.data.period.substr(0, 3)) + 1911}-${this.data.period.substr(3, 2)}-01`;
      const params = {
        ...this.search,
        'class': 1,
        'plan': this.data.plan,
        'bill_type': this.data.bill_type,
        'dead_date_S': getFirstAndLastDayOfMonth(period_first_date, true).first_day,
        'dead_date_E': getFirstAndLastDayOfMonth(period_first_date, true).last_day,
        'sortBy': this.table_sort.sortBy,
        'sort': this.table_sort.sort,
      };

      this.billApi.getBillFlatten((response) => {
        const res = response.data;

        this.table_data = res.data.map((item, index) => {
          return {
            ...item,
            no: index + 1
          }
        });

        this.initCsvData();

        this.status.isLoading = false;
      }, params, false)
    },
    // 初始化csv資料
    initCsvData() {
      let fields = {}, data = [];

      this.table_fields.forEach(fields_item => {
        fields = {
          ...fields,
          [fields_item.label]: fields_item.key
        }
      })

      this.table_data.forEach(data_item => {
        let temp_data = {};

        this.table_fields.forEach(fields_item => {
          if (fields_item.key === 'join_date' || fields_item.key === 'dead_line') {
            temp_data = {
              ...temp_data,
              [fields_item.key]: data_item[fields_item.key] ? convertDateFormat(data_item[fields_item.key], false) : ''
            }
          } else if (fields_item.key === 'type') {
            temp_data = {
              ...temp_data,
              [fields_item.key]: data_item[fields_item.key] !== null ? getBillFeeDescription(data_item[fields_item.key]) : ''
            }
          } else {
            temp_data = {
            ...temp_data,
              [fields_item.key]: data_item[fields_item.key] !== null ? data_item[fields_item.key] : ''
            }
          }
        })

        data.push(temp_data)
      })

      this.excel_json.fields = fields;
      this.excel_json.data = data;
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/billDataReportBillModal.vue